import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/videos')({
  component: VideosPage,
});

function VideosPage() {
  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-3xl font-bold mb-6">Videos</h1>
      <p className="text-muted-foreground">
        Video interview library and management. This page is under development.
      </p>
    </div>
  );
}
